module.exports = __webpack_public_path__ + "img/b-capabilities.ba771f7f.png";